/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/file_csv'
export default icon
